<template>
  <div class="layouts-block">
    <div
      v-bind:class="{
        'layout-button': true,
        'layout-button--active': isCardActive,
      }"
      @click="() => goToLayout('tile')"
    >
      <div class="layout-button__icon">
        <LottieIcon src="/static/card.json" />
      </div>
      <div v-if="isCardActive" class="layout-button__active-icon">
        <ActiveBasicLayoutIcon />
      </div>
      <div class="layout-name">TILE</div>
    </div>
    <div
      v-bind:class="{
        'layout-button': true,
        'layout-button--active': isSidebarActive,
      }"
      @click="() => goToLayout('sidebar')"
    >
      <div class="layout-button__icon">
        <LottieIcon src="/static/sidebar.json" />
      </div>
      <div v-if="isSidebarActive" class="layout-button__active-icon">
        <ActiveSidebarLayoutIcon />
      </div>
      <div class="layout-name">SIDEBAR</div>
    </div>
    <div
      v-bind:class="{
        'layout-button': true,
        'layout-button--active': isTableActive,
      }"
      @click="() => goToLayout('classic')"
    >
      <div class="layout-button__icon">
        <LottieIcon src="/static/classic.json" />
      </div>
      <div v-if="isTableActive" class="layout-button__active-icon">
        <ActiveTableLayoutIcon />
      </div>
      <div class="layout-name">
        CLASSIC
        <span class="layout-label">NEW</span>
      </div>
    </div>
  </div>
</template>

<script>
import LottieIcon from "./icons/LottieIcon";
import ActiveBasicLayoutIcon from "./icons/ActiveBasicLayoutIcon";
import ActiveSidebarLayoutIcon from "./icons/ActiveSidebarLayoutIcon";
import ActiveTableLayoutIcon from "./icons/ActiveTableLayoutIcon";

export default {
  name: "layoutSelect",
  components: {
    LottieIcon,
    ActiveBasicLayoutIcon,
    ActiveSidebarLayoutIcon,
    ActiveTableLayoutIcon,
  },
  methods: {
    goToLayout(layout) {
      this.$router.push(
        window.location.pathname
          .replace("/tile", "/" + layout)
          .replace("/classic", "/" + layout)
          .replace("/sidebar", "/" + layout)
      );
    },
  },
  computed: {
    isCardActive() {
      return this.$route.params.layout === "tile";
    },
    isSidebarActive() {
      return this.$route.params.layout === "sidebar";
    },
    isTableActive() {
      return this.$route.params.layout === "classic";
    },
  },
};
</script>

<style>
.layouts-block {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.layout-name {
  font-size: 10px;
  font-weight: bold;
  color: #1e313a;
  text-align: center;
  margin-top: 8px;
}
.layout-button {
  text-decoration: none;
  padding: 24px 16px 12px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.layout-button.layout-button--active .layout-button__icon {
  visibility: hidden;
}

.layout-button.router-link-active {
  background: white;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.05);
}

.layout-button svg {
  cursor: pointer;
}
.layout-button.router-link-active {
  cursor: default;
  pointer-events: none;
}
.layout-button__active-icon {
  position: absolute;
}
.layout-label {
  background: #ff4848;
  color: white;
  padding: 0 4px;
  border-radius: 4px;
  margin-left: 4px;
}
.layout-button path,
.layout-button rect {
  fill: rgba(74, 74, 74, 0.2);
  transition: fill 0.5s;
}
.layout-button--active path,
.layout-button--active rect {
  fill: #0821ff;
}

@media (max-width: 600px) {
  .layout-button {
    margin: 0;
    padding-left: 7px;
    padding-right: 7px;
  }
}
@media (max-width: 374px) {
  .layout-button {
    padding-left: 4px;
    padding-right: 4px;
  }
}
@media (hover: hover) {
  .layout-button:not(.layout-button--active):hover path,
  .layout-button:not(.layout-button--active):hover rect {
    fill: rgba(8, 33, 255, 0.3);
  }
}
</style>
